import { render, staticRenderFns } from "./table-view.vue?vue&type=template&id=3702cd18&scoped=true&"
import script from "./table-view.vue?vue&type=script&lang=js&"
export * from "./table-view.vue?vue&type=script&lang=js&"
import style0 from "./table-view.vue?vue&type=style&index=0&id=3702cd18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3702cd18",
  null
  
)

export default component.exports